import logoImg from "../../assets/qimah_logo.png";
import styles from "./Brand.module.css";
import { BrandSize, brandCopy } from "./Brand.controller";

type BrandProps = {
  size?: BrandSize;
  className?: string;
};

const Brand = ({ size = "default", className = "" }: BrandProps) => {
  const wrapperClassName = [styles.brand, className].filter(Boolean).join(" ");
  const logoClassName = [
    styles.logoImgWrap,
    size === "compact" ? styles.small : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={wrapperClassName}>
      <div className={logoClassName}>
        <img src={logoImg} alt="QIMAH logo" className={styles.logoImg} />
      </div>
      <div className={styles.brandCopy}>
        <div className={styles.brandName}>{brandCopy.name}</div>
        {/* <div className={styles.brandTag}>{brandCopy.tagline}</div> */}
      </div>
    </div>
  );
};

export default Brand;
